// Globals
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

// Locals
import AccountUploadPhotoModal from './AccountUploadPhotoModal';

// Types
import { IState } from '../../graphql/types';
import { Avatar, Button, Flex } from 'antd';
import { UserOutlined } from '@ant-design/icons';

const AccountUploadPhoto: React.FC = () => {
  const avatarUrl = useSelector<IState, string | undefined>(
    state => state.avatar
  );
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <Flex vertical gap={'small'}>
      <AccountUploadPhotoModal
        showModal={showModal}
        setShowModal={setShowModal}
      />
      <Flex justify={'center'} vertical={true} align={'center'} gap={'middle'}>
        <Avatar src={avatarUrl} size={128} icon={<UserOutlined />} />
        <Button
          type={'default'}
          style={{ margin: 'auto' }}
          onClick={() => setShowModal(true)}
        >
          Change Profile Photo
        </Button>
      </Flex>
    </Flex>
  );
};

export default AccountUploadPhoto;
